<div
  class="min-w-[200px] w-full md:w-max p-sm rounded-sm bg-contrast border border-ui-separator md:hover:bg-ui-hover flex items-center gap-sm cursor-pointer {{
    extraClasses
  }}"
>
  <svg-icon [key]="icon" class="text-base! shrink-0"></svg-icon>
  @if (showLabel) {
    <div class="flex-1 overflow-hidden">
      @if (value) {
        <div class="text-sm leading-sm truncate text-txt">{{ prefix }}{{ value }}</div>
      } @else {
        <div
          class="text-sm leading-sm truncate text-txt-disabled"
          [ngClass]="{ capitalize: capitalizeLabel }"
        >
          {{ label }}
        </div>
      }
    </div>
  }
  @if (showArrow) {
    <svg-icon key="arrow-down-simple" class="text-xs! shrink-0"></svg-icon>
  }
  <ng-content></ng-content>
</div>
